import {ArrayFilter, Condition} from '@/model/types';
import {Filters} from '../filters';

type QueryOptions = {
  includeHiddenFields?: boolean;
};

const hasAnyRowIn = <TValues extends string[]>(query: string, values: TValues, options: QueryOptions = {}) =>
  ({
    operator: '!=',
    field: {$query: query, filters: [Filters.value.isIn(values)], transform: 'count', ...options},
    value: 0,
  }) as const satisfies Condition;

const hasNoRowIn = <TValues extends string[]>(query: string, values: TValues, options: QueryOptions = {}) =>
  ({
    operator: '=',
    field: {$query: query, filters: [Filters.value.isIn(values)], transform: 'count', ...options},
    value: 0,
  }) as const satisfies Condition;

/**
 * Same as `hasAnyRowIn`, but discards the rows for which `where` does not hold. Array filters
 * compare another field of the same row, so use `{$index}` to target it (see `Filters.array`).
 */
const hasAnyRowInWhere = <TValues extends string[]>(
  query: string,
  values: TValues,
  where: ArrayFilter[],
  options: QueryOptions = {},
) =>
  ({
    operator: '!=',
    field: {$query: query, filters: [Filters.value.isIn(values), ...where], transform: 'count', ...options},
    value: 0,
  }) as const satisfies Condition;

export const QueryHelper = {
  hasAnyRowIn,
  hasAnyRowInWhere,
  hasNoRowIn,
};
